import { Container } from '@/components/layout/container'

import { cx } from '@/lib/cva-config'

export function AuthContainer(props: React.ComponentProps<typeof Container>) {
  const { className, ...rest } = props
  return (
    <Container>
      <div
        {...rest}
        className={cx('flex items-center justify-center py-8', className)}
      />
    </Container>
  )
}
